import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { updateAbout } from "../../api/apiAbout";

export const useUpdateAbout = () => {
    const queryClient = useQueryClient();
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || "en").startsWith("ar");

    const mutation = useMutation({
        mutationFn: (data) => updateAbout(data),
        onSuccess: (response) => {
            queryClient.invalidateQueries({ queryKey: ["about"] });
            toast.success(response?.message || (isArabic ? "تم تحديث من نحن" : "About Us updated"));
        },
        onError: (error) => {
            const message = error?.response?.data?.message || (isArabic ? "تعذر التحديث" : "Failed to update");
            toast.error(message);
        },
    });

    return mutation;
};
